import { render, staticRenderFns } from "./BlogCategory.vue?vue&type=template&id=cf98a738&"
import script from "./BlogCategory.vue?vue&type=script&lang=js&"
export * from "./BlogCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports